import { render, staticRenderFns } from "./posterListCopy.vue?vue&type=template&id=bf91d85e&"
import script from "./posterListCopy.vue?vue&type=script&lang=js&"
export * from "./posterListCopy.vue?vue&type=script&lang=js&"
import style0 from "./posterListCopy.vue?vue&type=style&index=0&id=bf91d85e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports